import { Text } from '@mantine/core'
import { ReactNode } from 'react'
import { useDeveloperMode } from './useDeveloperMode'

interface PlaceholderContentProps {
  children: ReactNode
  showFallback?: boolean
}

export function PlaceholderContent({
  children,
  showFallback,
}: PlaceholderContentProps) {
  const { isDeveloperMode } = useDeveloperMode()

  if (!isDeveloperMode) {
    return showFallback ? <Text>Tulossa pian...</Text> : null
  }

  return <>{children}</>
}
